export default "__VITE_ASSET__3b323797__"